import React from 'react';
import { ErrorBoundary, renderDefaultError } from './ErrorBoundary';

import './AdminLayout.scss';

export interface AdminLayoutProps {
  menu: NonNullable<React.ReactNode>;
  children: NonNullable<React.ReactNode>;
}

export const AdminLayout: React.FC<AdminLayoutProps> = (props: AdminLayoutProps) => (
  <div className='dmx-adminLayout'>
    <div>{props.menu}</div>
    <main>
      <ErrorBoundary fallback={renderDefaultError}>{props.children}</ErrorBoundary>
    </main>
  </div>
);
